import { deleteItem } from '../common/services/api'
import { gaEvent } from '../common/services/analytics'
import * as DataOperations from './Data'

export function deleteDocument(id, listId) {
  return (dispatch) => {
    return deleteItem(id, listId)
      .then(() => {
        dispatch(DataOperations.loadList(listId))
        gaEvent({
          category: 'Documents',
          action: `Deleted a document`,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
